import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorService } from '../services/editor.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { InlineBlockButtonsComponent } from './inline-block-buttons/inline-block-buttons.component';
import { BlockIframeEditorComponent } from './inline-edit-iframe/block-editor-modal/block-iframe-editor-modal.component';
import { MatIconModule } from '@angular/material/icon';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EditorTopPanelComponent } from './editor-top-panel/editor-top-panel.component';
import { LanguageChangeDialogComponent } from './language-change-dialog/language-change-dialog.component';
import { AsButtonComponent } from '../shared/as-components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AsButtonToggleModule } from '../shared/as-components/button-toggle/button-toggle.module';
import { AsInputModule } from '../shared/as-components/input/input.module';
import { EditableImageDirective } from './directive/editable-image.directive';
import { QuillModule } from 'ngx-quill';
import { MatMenuModule } from '@angular/material/menu';
import { PageSettingsEditorComponent } from './editor-top-panel/page-settings-editor/page-settings-editor.component';
import { PageSettingsSeoComponent } from './editor-top-panel/page-settings-seo/page-settings-seo.component';
import { PageTemplatesEditorComponent } from './editor-top-panel/page-templates-editor/page-templates-editor.component';
import { PageBackgraunSettingComponent } from './editor-top-panel/page-backgraun-setting/page-backgraun-setting.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { AsInputTextareaModule } from '../shared/as-components/input-textarea/input-textarea.module';
import { ToggleSwitchModule } from '../shared/as-components/toggle-switch/toggle-switch.module';
import { AsMultiselectModule } from '../shared/as-components/multiselect/multiselect.module';
import { CustomModalModule } from '../shared/as-components/custom-modal/custom-modal.module';
import { InlineComponentEditorComponent } from './inline-component-editor/inline-component-editor.component';
import { EditorTopPanelClassicComponent } from './editor-top-panel/ediot-top-view-classic/editor-top-panel-classic.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InlineEditSliderComponent } from './inline-edit-slider/inline-edit-slider.component';
import { InlineEdiotSliderSelectColorComponent } from './inline-edit-slider/inline-edit-slider-select-color/inline-ediot-slider-select-color.component';
import { InlineTextEditorComponent } from './inline-edit-text/inline-text-editor-component.component';
import { PickerColorInlineEditorComponent } from './inline-edit-text/picker-color-inline-editor/picker-color-inline-editor.component';
import { InlineImageEditorLinkComponent } from './inline-edit-image/inline-image-editor-link/inline-image-editor-link.component';
import { InlineImageEditorComponent } from './inline-edit-image/inline-image-editor.component';
import { EditableImageWrapperComponent } from './inline-edit-image/inline-image-editor-wrapper/inline-image-editor.component';
import { InlineImageEditorAltComponent } from './inline-edit-image/inline-image-editor-alt/inline-image-editor-alt.component';
import { DynamicHostComponent } from './inline-edit-slider/dynamic-host.component';

@NgModule({
  imports: [
    MatSelectModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatMenuModule,
    MatInputModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    CommonModule,
    FormsModule,
    QuillModule,
    CdkTextareaAutosize,
    AsButtonToggleModule,
    AsButtonComponent,
    TranslateModule,
    AsInputModule,
    ReactiveFormsModule,
    AsInputTextareaModule,
    ToggleSwitchModule,
    AsMultiselectModule,
    CustomModalModule,
    EditableImageDirective,
    DragDropModule,
  ],
  declarations: [
    InlineBlockButtonsComponent,
    InlineTextEditorComponent,
    BlockIframeEditorComponent,
    EditorTopPanelComponent,
    LanguageChangeDialogComponent,
    PickerColorInlineEditorComponent,
    InlineImageEditorLinkComponent,
    InlineImageEditorComponent,
    PageSettingsEditorComponent,
    PageSettingsSeoComponent,
    PageTemplatesEditorComponent,
    PageBackgraunSettingComponent,
    EditableImageWrapperComponent,
    InlineImageEditorAltComponent,
    InlineComponentEditorComponent,
    EditorTopPanelClassicComponent,
    InlineEditSliderComponent,
    InlineEdiotSliderSelectColorComponent,
    DynamicHostComponent,
  ],
  providers: [EditorService],
  exports: [EditorTopPanelComponent],
})
export class EditorInlineModule {}
